import PromotionBannerWrapper from 'components/PromotionBanner/PromotionBannerWrapper';

export default PromotionBannerWrapper;
